import { getErrorMessage } from 'application/util/error.util';

import './about.style.sass';
import template from './about.tpl.pug';

class AboutSettingsController {
    /* @ngInject */
    constructor($window, configuration, diagnosticsService, notificationService, sessionService) {
        this.$window = $window;
        this.configuration = configuration;
        this.diagnosticsService = diagnosticsService;
        this.notificationService = notificationService;
        this.sessionService = sessionService;
    }

    $onInit() {
        this.facebookUrl = this.configuration.socialFacebookUrl;
        this.twitterUrl = this.configuration.socialTwitterUrl;
        this.helpCenterUrl = this.configuration.helpCenterUrl;
        this.supportEmail = this.configuration.supportEmail;
        this.version = this.configuration.version;
        this.canSendDiagnostics = this.diagnosticsService.canSend();
        this.buildSupportMailDraft();

        this.sessionService.initialize()
            .then((data) => {
                this.plan = data && data.plan ? data.plan : this.plan;
                this.buildSupportMailDraft();
            })
            .catch(() => null);
    }

    sendDiagnostics() {
        return this.diagnosticsService.send({
            source: 'settings-about',
            userId: this.sessionService && this.sessionService.user && this.sessionService.user.id,
            identity: this.sessionService && this.sessionService.user && this.sessionService.user.email
        }).then((result) => {
            const diagnosticsId = result && result.data && result.data.id;
            const message = diagnosticsId
                ? `Diagnostics sent. ID: ${diagnosticsId}`
                : `Diagnostics sent. Thank you.`;

            this.notificationService.showInfo(message, null, true, 6000);
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to send diagnostics. Please try again later.`));
        });
    }

    buildSupportMailDraft() {
        const user = this.sessionService && this.sessionService.user ? this.sessionService.user : {};
        const planName = this.getPlanTypeName(this.plan);
        const userAgent = this.$window && this.$window.navigator ? this.$window.navigator.userAgent : null;
        const appUrl = this.$window && this.$window.location ? this.$window.location.href : null;

        this.supportMailSubject = `Customer Support (Web, ${planName})`;
        this.supportMailBody = [
            `Platform: Web, version: ${this.version || 'unknown'}, userID: ${user && user.id ? user.id : 'unknown'}, userEmail: ${user && user.email ? user.email : 'unknown'}`,
            `Browser: ${userAgent || 'unknown'}`,
            `baseUrl: ${this.configuration && this.configuration.api ? this.configuration.api : 'unknown'}`,
            `appUrl: ${appUrl || 'unknown'}`
        ].join('\n');
    }

    getPlanTypeName(plan) {
        const value = plan && (
            plan.planType_name ||
            plan.planTypeName ||
            plan.type_name ||
            plan.typeName ||
            plan.name ||
            plan.subscription && plan.subscription.type
        );

        return value || 'unknown';
    }
}

export default {
    selector: 'dbAAbout',
    template: template(),
    controller: AboutSettingsController
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/about/about.cmpt.js